<template>
  <div class="animated fadeIn omset-kota">
    <b-card :title="$route.meta.label">
      <b-row>
        <b-col lg="10" xl="7">
          <b-input-group>
            <b-input-group-prepend>
              <span class="pt-2 mr-2">Tanggal/Edisi</span>
            </b-input-group-prepend>
            <b-form-input v-model="filter.tgl1" type="date" :state="!$v.filter.tgl1.$error"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="filter.tgl2" type="date" @change="updateTgl1" :state="!$v.filter.tgl1.$error"></b-form-input>
            <b-input-group-prepend>
              <span class="pt-2 ml-2 mr-2">Type Chart</span>
            </b-input-group-prepend>
            <b-form-select v-model="typechart" :options="opttypechart" :plain="true"></b-form-select>
            <b-input-group-append>
              <b-button class="btn btn-success ml-2" @click="process()">
                <i class="fa fa-play"></i> Process
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <div v-if="typechart==='pie'" class="small">
        <pie-chart :chart-data="datacollection" :options="chartOptions" @click="chartClickEvent" />
        <b-row class="justify-content-center mb-4">{{ datacollection.periode }}</b-row>
        <b-row class="justify-content-center">
          <div style="font-weight: bold;" class="ml-1">
            Total Sales : {{uanguser}}
            <div
              style="text-align:right; border:1px solid silver; width:200px;height:30px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;"
              class="pl-2 pt-2 pr-2"
            >{{totalSales | numFormat('0,0.00')}}</div>
          </div>
        </b-row>
      </div>
      <div v-if="typechart==='bar'" class="small">
        <bar-chart
          :chart-data="datacollection"
          :options="chartOptions"
          @click="chartClickEvent"
          v-if="(dataLoaded==true)"
        />
        <b-row class="justify-content-center mb-4">Year of {{ filter.tgl2 | moment("YYYY") }}</b-row>
        <b-row class="justify-content-center">
          <div style="font-weight: bold;" class="ml-1">
            Total Sales : {{uanguser}}
            <div
              style="text-align:right; border:1px solid silver; width:200px;height:30px;border-top: 1px solid #000 ;border-bottom: 2px solid #000; background: #e6e6e6; display:inline;"
              class="pl-2 pt-2 pr-2"
            >{{totalSales | numFormat('0,0.00')}}</div>
            <span>million</span>
          </div>
        </b-row>
      </div>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="drillDownShow"
      :title="`Detail Sales ${drillDataset[0].kota_name}`"
      :centered="true"
      ok-only
    >
      <p
        class="font-weight-bold text-danger"
        v-if="(drillDataset.length>0)"
      >Period: {{drillDataset[0].periode}}</p>
      <b-link
        @click="drillDown(drillDataset[0])"
      >Total sales : {{uanguser}} {{drillTotal | numFormat('0,0.00')}} ({{persentasi | numFormat('0,0.00')}} %)</b-link>
      <p class="m-0 text-danger text-right">Click above link, to Show Detail Sales Transaction !</p>
    </b-modal>

    <b-modal
      v-model="drillDownShow2"
      :title="`Detail Sales ${drillDataset[0].kota_name}`"
      :centered="true"
      ok-only
    >
      <p
        class="font-weight-bold text-danger"
        v-if="(drillDataset.length>0)"
      >Period: {{drillDataset[0].periode}}</p>
      <b-input-group v-for="row in drillDataset" :key="row.kota_id" class="ml-2 mr-3 text-right">
        <b-input-group-prepend>
          <label>{{row.kota_name}}</label>
        </b-input-group-prepend>
        <b-link
          @click="drillDown(row)"
          style="width:200px;"
        >{{uanguser}} {{row.sales | numFormat('0,0.00')}} ({{row.persentasi | numFormat('0,0.00')}} %)</b-link>
      </b-input-group>
      <b-input-group class="ml-2 mr-3 text-right">
        <b-input-group-prepend>
          <label>TOTAL</label>
        </b-input-group-prepend>
        <b-link
          @click="drillDown(datacollection)"
          style="width:200px;"
        >{{uanguser}} {{drillTotal | numFormat('0,0.00')}} ({{persentasi | numFormat('0,0.00')}} %)</b-link>
      </b-input-group>

      <p class="m-0 text-danger text-right">Click above link, to Show Detail Sales Transaction !</p>
    </b-modal>

  </div>
</template>

<style lang="scss" >
  .omset-kota{
    .small {
      max-height: 600px;
      max-width: 1280px;
      margin: 100px auto;
    }
  }
</style>


<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import koranreport from "../../apis/koran_report";
import PieChart from "../../components/chartPie";
// import dropdown from "../../data/dropdown";
import BarChart from "../../components/chartBar";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    filter: {
      tgl1: { required },
      tgl2: { required }
    }
  },
  data() {
    return {
      filter: { tgl1: "", tgl2: "", periode: "" },
      drillDownShow: false,
      drillDownShow2: false,
      drillDataset: [{}],
      drillTotal: 0,
      persentasi: 0,
      isLoading: false,
      reportUrl: null,
      showReport: false,
      uanguser: this.$store.state.user.matauang,
      totalSales: 0,
      chartOptions: {
        tooltips: {
          mode: "index",
          intersect: false
        },
        responsive: true,
        maintainAspectRatio: false
      },
      dataLoaded: false,
      datacollection: {},
      opttypechart: [
        { value: "pie", text: "Pie Chart" },
        { value: "bar", text: "Bar Chart" }
      ],
      typechart: "pie"
    };
  },
  components: { Loading, PieChart, BarChart },
  computed: {
    invalidFilter() {
      this.$v.filter.$touch();
      return this.$v.filter.$invalid;
    }
  },
  created: async function() {
    let tgl1 = moment();
    this.filter.tgl1 = tgl1.startOf("month").format("YYYY-MM-DD");
    this.filter.tgl2 = tgl1.endOf("month").format("YYYY-MM-DD");
    this.datacollection.labels = ["Jabodetabek"];
    // for (let index = 0; index < (tgl1.endOf('month').format('D')*1); index++) {
    //     this.datacollection.labels.push(`D#${index+1}`);
    // }
    // this.chartOptions.scales.xAxes[0].scaleLabel.labelString= tgl1.endOf('month').format('MMMM YYYY') ;
    this.datacollection.datasets = [
      {
        // label: 'Data One',
        backgroundColor: ["#30475e"],
        data: [1]
      }
    ];
    this.dataLoaded = true;
  },
  methods: {
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    updateTgl1: function() {
      if (!this.filter.tgl1) {
        var tgl2 = moment(this.filter.tgl2, "YYYY-MM-DD");
        var tgl1 = moment(tgl2.format("YYYY") + "-01-01", "YYYY-MM-DD");
        this.filter.tgl1 = tgl1.format("YYYY-MM-DD");
      }
    },
    process: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
        this.isLoading = true;
        try {
          this.dataLoaded = false;
          this.datacollection = await koranreport.omsetkotachart(this.filter);
          this.datacollection.kota_id = this.filter.kota_id;
          this.datacollection.kota_name = this.filter.kota_name;
          this.datacollection.tgl1 = this.filter.tgl1;
          this.datacollection.tgl2 = this.filter.tgl2;
          var tgl1 = moment(this.filter.tgl1, "YYYY-MM-DD");
          var tgl2 = moment(this.filter.tgl2, "YYYY-MM-DD");
          this.datacollection.periode = `${tgl1.format(
            "DD-MMM-YYYY"
          )} until ${tgl2.format("DD-MMM-YYYY")}`;
          this.totalSales = 0;
          this.datacollection.datasets.forEach(ds => {
            this.totalSales += ds.data.reduce((a, b) => a + b, 0);
          });
          this.datacollection.datasets[0].label = this.$route.meta.label;
          this.dataLoaded = true;
          this.isLoading = false;
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }  
        }
      }
    },
    chartClickEvent: function(option) {
      const { event, array } = option;
      this.drillDataset = [];
      this.drillTotal = 0;
      this.persentasi = 0;
      array.forEach((ar, idx) => {
        var dayidx = ar._index;
        this.drillDataset.push({
          kota_name: this.datacollection.labels[dayidx],
          kota_id: this.datacollection.kota_ids[dayidx],
          periode: this.datacollection.periode,
          tgl1 : this.filter.tgl1,
          tgl2 : this.filter.tgl2,
          sales: ar._chart.data.datasets[idx].data[dayidx],
          persentasi:
            (parseFloat(ar._chart.data.datasets[idx].data[dayidx]) /
              (this.totalSales || 1)) *
            100,
          dayidx
        });
        this.drillTotal += ar._chart.data.datasets[idx].data[dayidx];
        this.datacollection.kota_name = this.datacollection.labels[dayidx];
        this.datacollection.kota_id = this.datacollection.kota_ids[dayidx];
      });
      this.persentasi = (this.drillTotal / (this.totalSales || 1)) * 100;
      console.log('this.drillDataset : ', this.drillDataset);
      if (this.drillDataset.length === 1) {
        this.drillDownShow = true;
      } else {
        this.drillDownShow2 = true;
      }
    },

    drillDown: function(data) {
      if (data.tgl1) {
        let routeData;
        if (data.kota_id) {
          const queryStr=`omset-kota-list/${data.tgl1}/${data.tgl2}/${data.kota_id || ""}/${data.kota_name || ""}`;
          console.log('queryStr: ',queryStr);

          routeData = router.resolve({
            path: `omset-kota-list/${data.tgl1}/${data.tgl2}/${data.kota_id || ""}/${data.kota_name || ""}`
          });
        } else {
          routeData = router.resolve({
            path: `omset-kota-list/${data.tgl1}/${data.tgl2}`
          });
        }
        window.open(routeData.href, "_blank");
      } else {
        let routeData;
        if (this.datacollection.kota_id) {
          routeData = router.resolve({
            path: `omset-kota-list/${this.datacollection.tgl1}/${this.datacollection.tgl2}/${this.datacollection.kota_id ||
              ""}/${this.datacollection.kota_name || ""}`
          });
        } else {
          routeData = router.resolve({
            path: `omset-kota-list/${this.datacollection.tgl1}/${this.datacollection.tgl2}`
          });
        }
        window.open(routeData.href, "_blank");
      }
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>
